<template>
  <section :class="$style.container" data-luko-tracking="OptionContent">
    <Wrapper :class="$style.wrapper">
      <div :class="$style.summary">
        <Title :title-params="primary.title" :class="$style.title" />
        <RichText
          v-if="primary.description"
          :text-params="primary.description"
          :class="$style.description"
        />
        <PLink
          v-if="primary.link_text && primary.link_text.length"
          :link-object="primary.link"
          :class="$style.link"
          is-highlight
          color="bluko"
        >
          <RichText v-if="primary.link_text" :text-params="primary.link_text" />
        </PLink>

        <div :class="$style.highlightContainer">
          <RichText v-if="primary.highlight" :text-params="primary.highlight" />
        </div>
      </div>

      <div
        v-observe-visibility="{
          callback: isShown,
          intersection: {
            rootMargin: '-25% 0% -25% 0%',
          },
        }"
        :class="$style.detail"
      >
        <template v-if="isDayStep">
          <div :class="$style.daySteps">
            <div
              v-for="(item, item_index) in items"
              :key="'item_' + item_index"
            >
              <DayStep
                :item="item"
                :class="[$style.dayStep, { [$style.popup]: doAnimation }]"
                :style="{
                  animationDelay: `${
                    0.3 + 0.05 * item_index * (1 + dots.length)
                  }s`,
                }"
              />
              <div
                v-if="item_index + 1 !== items.length"
                :class="$style.dotContainer"
              >
                <div
                  v-for="(dot, dot_index) in dots"
                  :key="'dot_' + dot_index"
                  :class="[$style.dot, { [$style.popup]: doAnimation }]"
                  :style="{
                    animationDelay: `${
                      0.3 +
                      0.05 * (item_index * (1 + dots.length) + 1 + dot_index)
                    }s`,
                  }"
                ></div>
              </div>
            </div>
          </div>
        </template>
        <template v-else>
          <BoxStep
            v-for="(item, box_index) in items"
            :key="'box_' + box_index"
            :class="[$style.boxStep, { [$style.fade]: doAnimation }]"
            :item="item"
          />
        </template>
      </div>
    </Wrapper>
  </section>
</template>

<script>
import Title from '~/components/Title'
import RichText from '~/components/RichText'
import PLink from '~/components/PLink'

import DayStep from './components/DayStep'
import BoxStep from './components/BoxStep'

export default {
  name: 'LukonTerminationOptionContent',

  components: {
    Title,
    RichText,
    PLink,
    BoxStep,
    DayStep,
  },
  props: {
    slice: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      primary: this.slice.primary,
      items: this.slice.items,
      shown: false,
      dots: [0, 1, 2],
    }
  },
  computed: {
    isDayStep() {
      return !!this.items.filter((item) => Object.keys(item.icon).length).length
    },
    doAnimation() {
      return this.shown
    },
  },
  methods: {
    isShown(visible) {
      if (visible && !this.shown) this.shown = true
    },
  },
}
</script>

<style lang="scss" module>
.container {
  margin: 87px 0 170px;
  padding: 0 24px;
  @include below(small) {
    margin: 80px 0;
  }
}

.wrapper {
  display: flex;
  justify-content: space-evenly;
  max-width: 1280px;
  margin: 0 auto;

  @include below(small) {
    flex-direction: column;
  }
}

.summary {
  @include typo-body;
  @include below(small) {
    width: 90%;
    margin: 0 auto 48px;
  }

  width: 45%;
  max-width: 500px;

  .title {
    @include typo-large-title;
    @include below(small) {
      text-align: center;
    }
  }
  .description {
    color: $gray-700;
    @include below(small) {
      text-align: center;
    }
  }
  .link {
    margin-top: 32px;
    margin-left: 10px;

    text-decoration: none;
    .linkSlot {
      display: flex;
      align-items: center;
    }
  }
  .highlightContainer {
    margin-top: 32px;
    padding: 24px;
    border-radius: 8px;

    color: $gray-700;

    background-color: #fff4ee;
    strong {
      color: $gray-1000;
    }
  }
}

.detail {
  @include below(small) {
    width: 90%;
    max-width: 480px;
    margin: 0 auto 60px;
  }
  width: 45%;
  max-width: 620px;

  .daySteps {
    display: block;
    .dayStep {
      opacity: 0;
    }
  }
  .dotContainer {
    margin: 10px 0;
    .dot {
      position: relative;
      left: 76px;

      width: 10px;
      height: 10px;

      background-image: url('@/assets/icons/lukon-termination/dot.svg');
      background-size: 10px 10px;
      opacity: 0;
    }
  }
  .boxStep {
    opacity: 0;
  }
}

.popup {
  animation: zoom 0.5s cubic-bezier(0.45, 1.33, 0.55, 0.92) 1 forwards;
}

.fade {
  animation: fade 0.3s ease-in-out forwards;
}

@keyframes fade {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}

@keyframes zoom {
  from {
    transform: scale(0.7, 0);
    opacity: 1;
  }
  to {
    transform: initial;
    opacity: 1;
  }
}
</style>
